import React from 'react';
import styles from '../styles/picker.module.scss';
import { RangePicker as Picker } from 'rc-picker';
import enEN from 'rc-picker/lib/locale/en_US';
import 'rc-picker/assets/index.css';
import { Moment } from 'moment';
import generateConfig from 'rc-picker/lib/generate/moment';

export type RangeValue = [Moment | null, Moment | null] | null;

export default function RangePicker(props: {
  onChange: (newValue: RangeValue) => void;
  value?: RangeValue;
  placeholder?: [string, string];
}) {
  return (
    <Picker<Moment>
      locale={enEN}
      separator="..."
      value={props.value}
      onChange={props.onChange}
      generateConfig={generateConfig}
      className={styles.datePicker}
      dropdownClassName={styles.dropDown}
      picker="date"
      placeholder={props.placeholder || ['from', 'to']}
    />
  );
}
